import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/userAffirmationProgram/importer/userAffirmationProgramImporterActions';

export default importerReducers(actions);
